import {SearchOutlined} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  // Form,
  Input,
  Row,
  Space,
  Table,
  Tooltip,
  Menu,
  Checkbox,
  Dropdown,
} from 'antd';
import {useState} from 'react';
import {Link} from 'react-router-dom';
import {ReactComponent as ColumnList} from '../../Images/ColumnList.svg';
import {ReactComponent as Back} from '../../Images/Back.svg';
import {ReactComponent as FilterIcon} from '../../Images/FilterIcon.svg';

function IndentStatus() {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  // const [form] = Form.useForm();
  const [orderBy, setOrderBy] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const handleSearch = e => {
    setSearch(e.target.value);
    setPage(1); // Reset to first page on new search
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'name' && sortOrder === 'ascend') {
      sortingEnumKey = 'name';
    }
    if (sortField === 'name' && sortOrder === 'descend') {
      sortingEnumKey = '-name';
    }

    return sortingEnumKey;
  };

  const resetFilter = () => {
    setSearch('');
    setPage(1);
    setOrderBy('');
  };
  const handlePageChange = newPage => {
    setPage(newPage);
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setPageSize(pagination.pageSize);
    setOrderBy(orderBy);
  };
  const data = [
    {
      Sr_No: 1,
      Order_Date: '04/12/2024',
      Order_No: '24-25/1436',
      Party_Name: 'Prime interiors',
      Total_Weight: 220.33,
      Pending_Weight: 220.33,
      Dispatched_Weight: 226.7,
      Packed_Weight: 0.0,
      Delivery_Date: '16/12/2024',
      Purchase_Order_No: 'EXCESS STOCK',
      Purchase_Order_Date: '04/12/2024',
    },
  ];
  const rowSelection = {
    selectedRowKeys,
    onChange: selectedKeys => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'Sr_No',
      key: 'Sr_No',
    },
    {
      title: 'Order Date',
      dataIndex: 'Order_Date',
      key: 'Order_Date',
    },
    {
      title: 'Order No',
      dataIndex: 'Order_No',
      key: 'Order_No',
    },
    {
      title: 'Party Name',
      dataIndex: 'Party_Name',
      key: 'Party_Name',
    },
    {
      title: 'Total Weight',
      dataIndex: 'Total_Weight',
      key: 'Total_Weight',
    },
    {
      title: 'Pending Weight',
      dataIndex: 'Pending_Weight',
      key: 'Pending_Weight',
    },
    {
      title: 'Dispatched Weight',
      dataIndex: 'Dispatched_Weight',
      key: 'Dispatched_Weight',
    },
    {
      title: 'Packed Weight',
      dataIndex: 'Packed_Weight',
      key: 'Packed_Weight',
    },
    {
      title: 'Delivery Date',
      dataIndex: 'Delivery_Date',
      key: 'Delivery_Date',
    },
    {
      title: 'Purchase Order No',
      dataIndex: 'Purchase_Order_No',
      key: 'Purchase_Order_No',
    },
    {
      title: 'Purchase Order Date',
      dataIndex: 'Purchase_Order_Date',
      key: 'Purchase_Order_Date',
    },
  ];

  const [checkedList, setCheckedList] = useState([
    'Sr_No',
    'Party_Name',
    'Order_Date',
    'Order_No',
    'Packed_Weight',
    'Dispatched_Weight',
    'Pending_Weight',
    'Total_Weight',
    'Delivery_Date',
    'Purchase_Order_No',
    'Purchase_Order_Date',
  ]);

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );
  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="Sr_No" disabled>
                Sr. No.
              </Checkbox>
            </Col>

            <Col span={12}>
              <Checkbox value="Order_Date">Order Date</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="Order_No">Order No</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="Party_Name">Party Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="Total_Weight">Total Weight</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="Pending_Weight">Pending Weight</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="Dispatched_Weight">Dispatched Weight</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="Packed_Weight">Packed Weight</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="Delivery_Date">Delivery Date</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="Purchase_Order_No">Purchase Order No</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="Purchase_Order_Date">
                Purchase Order Date
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Row className="pagenamerow" justify="space-between" align="middle">
        <Col>
          <h2 style={{margin: 0}}>Work Orders Pending From Last Week</h2>
          <div className="bredcrumbwrp">
            <Link to="/dashboard" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                {title: <Link to="/dashboard">Home</Link>},
                {title: 'Work Orders Pending From Last Week'},
              ]}
            />
          </div>
        </Col>
        <Col style={{display: 'flex', alignItems: 'center'}}>
          <Space>
            <Input
              placeholder="Search"
              className="searchbox"
              prefix={<SearchOutlined />}
              value={search}
              style={{width: 200}}
              onChange={handleSearch}
            />
            <Tooltip placement="top" title="Reset Filter">
              <Button
                type="primary"
                disabled={!search && !orderBy}
                className="iconlink"
                onClick={resetFilter}
              >
                <FilterIcon />
              </Button>
            </Tooltip>

            <Link>
              <Tooltip placement="topLeft" title="Column Filter Options">
                <Dropdown
                  overlay={columnMenu}
                  trigger={['click']}
                  placement="bottomRight"
                  visible={dropdownVisible}
                  onVisibleChange={setDropdownVisible}
                >
                  <Button
                    type="primary"
                    icon={<ColumnList />}
                    onClick={e => e.preventDefault()}
                  />
                </Dropdown>
              </Tooltip>
            </Link>
          </Space>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Table
            rowKey="id"
            columns={filteredColumns}
            dataSource={data}
            pagination={{
              current: page,
              pageSize: pagesize,
              showTotal: total => `Total ${total} items`,
              onChange: handlePageChange,
            }}
            onChange={handleTableChange}
          />
        </Col>
      </Row>
    </>
  );
}

export default IndentStatus;
